// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-container {
    width: 100%;
}

/* Week Header */
.week-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
}

.week-title {
    font-size: 16px;
    font-weight: bold;
}

.week-range {
    font-size: 14px;
}

.week-navigation {
    position: absolute;
    top: 1.5rem;
    right: 1.5rem;
}

.week-navigation button {
    width: 48px;
    height: 48px;
    background-color: #fff;
    border: none;
    border-radius: 100%;
    font-size: 1.5em;
    vertical-align: middle;
}
.week-navigation button +button{
    margin-left: 1rem;
}


.week-navigation button:hover {
    
}
.week-navigation button:focus{
    box-shadow: rgba(76, 91, 106, 0.5) 0px 0px 0px 0.2rem;
}

/* Calendar Rows */
.calendar-row {
    display: flex;
    align-items: center;
    padding: 10px 0;
    border-bottom: 2px dashed #ddd;
}

.calendar-row:last-child {
    border-bottom: none;
    padding-bottom: 0;
}

.date-box {
    width: 80px;
    text-align: left;
    display: flex;
    flex-direction: column;
}

.weekday {
    font-size: 18px;
    text-transform: uppercase;
    color: #5B767F;
}

.day {
    font-size: 16px;
    font-weight: 500;
}

.event-items-container {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    align-items: center;
    flex-grow: 1;
}

.event-item {
    position: relative;
    width: 280px;
    height: 106px;
    background-size: cover;
    background-position: center;
    border-radius: 10px;
    overflow: hidden;
    padding: 10px;
}
.event-item:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgb(0,0,0);
    background: linear-gradient(73deg, rgba(0,0,0,0.5018382352941176) 40%, rgba(8,34,87,0) 100%);
}
.event-item .time {
    display: none;
    color: #FFF;
    position: relative;
    z-index: 1;
}
.event-overlay {
    position: absolute;
    left: 10px;
    bottom: 10px;
    z-index: 1;
    color: #FFF;
    padding: 0;
    display: flex;
    flex-direction: column;
}

.event-title {
    font-size: 16px;
    font-weight: 500;
    line-height: normal;
}

.event-price {
    font-size: 18px;
    margin-top: 0;
    color: #FFF;
    line-height: normal;
    font-weight: 600;
}

.no-events {
    color: #5B767F;
    font-size: 16px;
    font-style: normal;
}

.event-heart {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(255, 255, 255, 0.7);
    padding: 5px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
}

.event-heart button {
    all: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    cursor: pointer;
}

.event-heart img {
    width: 15px;
    height: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/events/horizontalView/EventsCalendar.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;;;AAGA;;AAEA;AACA;IACI,qDAAqD;AACzD;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,4FAA4F;AAChG;AACA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,UAAU;IACV,WAAW;IACX,UAAU;IACV,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".calendar-container {\n    width: 100%;\n}\n\n/* Week Header */\n.week-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 18px;\n}\n\n.week-title {\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.week-range {\n    font-size: 14px;\n}\n\n.week-navigation {\n    position: absolute;\n    top: 1.5rem;\n    right: 1.5rem;\n}\n\n.week-navigation button {\n    width: 48px;\n    height: 48px;\n    background-color: #fff;\n    border: none;\n    border-radius: 100%;\n    font-size: 1.5em;\n    vertical-align: middle;\n}\n.week-navigation button +button{\n    margin-left: 1rem;\n}\n\n\n.week-navigation button:hover {\n    \n}\n.week-navigation button:focus{\n    box-shadow: rgba(76, 91, 106, 0.5) 0px 0px 0px 0.2rem;\n}\n\n/* Calendar Rows */\n.calendar-row {\n    display: flex;\n    align-items: center;\n    padding: 10px 0;\n    border-bottom: 2px dashed #ddd;\n}\n\n.calendar-row:last-child {\n    border-bottom: none;\n    padding-bottom: 0;\n}\n\n.date-box {\n    width: 80px;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n}\n\n.weekday {\n    font-size: 18px;\n    text-transform: uppercase;\n    color: #5B767F;\n}\n\n.day {\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.event-items-container {\n    display: flex;\n    gap: 15px;\n    flex-wrap: wrap;\n    align-items: center;\n    flex-grow: 1;\n}\n\n.event-item {\n    position: relative;\n    width: 280px;\n    height: 106px;\n    background-size: cover;\n    background-position: center;\n    border-radius: 10px;\n    overflow: hidden;\n    padding: 10px;\n}\n.event-item:before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background: rgb(0,0,0);\n    background: linear-gradient(73deg, rgba(0,0,0,0.5018382352941176) 40%, rgba(8,34,87,0) 100%);\n}\n.event-item .time {\n    display: none;\n    color: #FFF;\n    position: relative;\n    z-index: 1;\n}\n.event-overlay {\n    position: absolute;\n    left: 10px;\n    bottom: 10px;\n    z-index: 1;\n    color: #FFF;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.event-title {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: normal;\n}\n\n.event-price {\n    font-size: 18px;\n    margin-top: 0;\n    color: #FFF;\n    line-height: normal;\n    font-weight: 600;\n}\n\n.no-events {\n    color: #5B767F;\n    font-size: 16px;\n    font-style: normal;\n}\n\n.event-heart {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: rgba(255, 255, 255, 0.7);\n    padding: 5px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n}\n\n.event-heart button {\n    all: unset;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n}\n\n.event-heart img {\n    width: 15px;\n    height: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
